import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";

const CssTick = ({ size = 120 }) => (
  <div style={{ width: size, height: size, display: "inline-block" }} aria-hidden>
    <svg viewBox="0 0 120 120" width={size} height={size}>
      <defs>
        <linearGradient id="tick-gradient" x1="0%" x2="100%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="rgb(var(--theme-color))" />
          <stop offset="100%" stopColor="rgba(var(--theme-color), 0.8)" />
        </linearGradient>
      </defs>
      <circle
        cx="60"
        cy="60"
        r="54"
        fill="none"
        stroke="url(#tick-gradient)"
        strokeWidth="12"
        strokeLinecap="round"
        strokeDasharray="339.292"
        strokeDashoffset="339.292"
      >
        <animate attributeName="stroke-dashoffset" from="339.292" to="0" dur="0.6s" fill="freeze" />
      </circle>
      <path
        d="M36 62 L52 78 L84 44"
        fill="none"
        stroke="rgb(var(--theme-color))"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="100"
        strokeDashoffset="100"
      >
        <animate attributeName="stroke-dashoffset" from="100" to="0" dur="0.5s" begin="0.45s" fill="freeze" />
      </path>
    </svg>
  </div>
);

const PaymentSuccessModal = ({ open, onClose, payload }) => {
  const [confettiOn, setConfettiOn] = useState(false);

  useEffect(() => {
    if (open) {
      setConfettiOn(true);
      const t = setTimeout(() => setConfettiOn(false), 3000);
      return () => clearTimeout(t);
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(() => onClose?.(), 4500);
    return () => clearTimeout(timer);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="psm-overlay" role="dialog" aria-modal="true">
      {confettiOn && <Confetti recycle={false} numberOfPieces={200} />}
      <div className="psm-backdrop" onClick={onClose} />
      <div className="psm-card">
        <div className="psm-content">
          <CssTick />
          <h2 className="psm-title">Payment Successful</h2>
          <p className="psm-subtext">
            You’ve sent <span className="psm-amount">₹{payload.amount}</span>
          </p>

          <div className="psm-info">
            <div className="psm-row">
              <div>To</div>
              <div className="value">{payload.receiverName || "---"}</div>
            </div>
            <div className="psm-row">
              <div>Date</div>
              <div className="value">{payload.time || new Date().toLocaleString()}</div>
            </div>
            {payload.txnId && (
              <div className="psm-row">
                <div>Txn ID</div>
                <div className="value">{payload.txnId}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessModal;
